// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../szc.cycz.cc/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".upload-container[data-v-7702a5a8] {\n  padding: 0 20px 20px 20px;\n}\n.upload-container .customer-table[data-v-7702a5a8] {\n  margin-top: 20px;\n}\n.upload-container .customer-table .el-icon-delete[data-v-7702a5a8] {\n  margin-left: 5px;\n}\n.add-btn[data-v-7702a5a8] {\n  position: fixed;\n  right: 0;\n  top: 450px;\n  z-index: 99;\n}", ""]);
// Exports
module.exports = exports;
